var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 109,
    viewBox: "0 0 156 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.3774 4.42857L45.3832 108.143L9.17748 21.0229L0.628906 14.36L16.4689 0.405712L48.7774 77.8457L74.926 14.7371L66.7546 4.42857H88.3774ZM155.229 79.2286C155.229 87.2743 152.379 94.021 146.68 99.4686C141.065 104.916 134.276 107.64 126.314 107.64C114.413 107.64 103.853 104.623 94.6347 98.5886L108.086 87.1486L133.48 101.731C138.509 96.4514 141.023 91.2133 141.023 86.0171C141.023 79.1448 137.629 72.5238 130.84 66.1543C124.471 60.8743 118.101 55.5943 111.732 50.3143C104.943 43.9448 101.549 37.2819 101.549 30.3257C101.549 21.1905 104.189 14.1924 109.469 9.33142C114.162 4.88952 120.28 2.66857 127.823 2.66857C136.874 2.66857 145.507 5.6019 153.72 11.4686L141.4 22.28L117.64 9.08C115.042 13.6895 113.743 18.0057 113.743 22.0286C113.743 28.4819 117.347 34.8095 124.554 41.0114C131.175 46.3752 137.796 51.6971 144.417 56.9771C151.625 63.8495 155.229 71.2667 155.229 79.2286Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVs);
export default __webpack_public_path__ + "static/media/vs.caca7183c4fd5f302954a4cc1f3bfd2d.svg";
export { ForwardRef as ReactComponent };